import md5 from 'blueimp-md5';
import autosize from 'autosize';
import i18n from './plugins/i18n'
import Emoji from './plugins/emojis';
import {defaultConfig, VERSION, defaultMeta, QQCacheKey, MetaCacheKey, RandomStr} from './const'
import timeAgo from './utils/timeago'
import lcLoader from './loader/lcLoader'
import {fetchQQFn,recordIPFn} from './utils/thirdParty'
import ErrHandler from './utils/errorHandler'
import $ from './utils'
import md from './utils/md'
import xss from './utils/xss'
const defaultComment = {
    comment: '',
    nick: '',
    mail: '',
    link: '',
    ua: $.ua,
    url: '',
    QQAvatar:''
};
let TEMP_COMMENT_CTX = ''

let _avatarSetting = {
        cdn: 'https://gravatar.loli.net/avatar/',
        ds: ['mp', 'identicon', 'monsterid', 'wavatar', 'robohash', 'retro', ''],
        params: '',
        hide: false
    }

function ValineFactory(cfg) {
    !!cfg && this.init(cfg);
    return this;
}

/**
 * Valine Init
 */
ValineFactory.prototype.init = function (cfg) {
    if (typeof document === 'undefined') throw new Error('Sorry, Valine does not support Server-side rendering.')
    let vm = this
    if(!!cfg) {
        cfg = $.extend(defaultConfig, cfg)
        vm.i18n = i18n((cfg['lang'] || $.lang), cfg['langMode'])
        vm['cfg'] = cfg
        Emoji['maps'] = !!cfg['emojiMaps'] && cfg['emojiMaps'] || Emoji['maps']
        Emoji['cdn'] = !!cfg['emojiCDN'] && cfg['emojiCDN'] || Emoji['cdn']
        vm._init();
    }
    return vm;
}

ValineFactory.prototype._init = function(){
    let vm = this;
    try {
        let {
            avatar,
            avatarForce,
            avatar_cdn,
            visitor,
            path = location.pathname,
            pageSize,
            recordIP,
        } = vm.cfg;
        vm['config']['path'] = path.replace(/index\.html?$/, '');
        let ds = _avatarSetting['ds'];
        let force = avatarForce ? '&q=' + RandomStr : '';
        _avatarSetting['params'] = `?d=${(ds.indexOf(avatar) > -1 ? avatar : 'mp')}&v=${VERSION}${force}`;
        _avatarSetting['hide'] = avatar === 'hide';
        _avatarSetting['cdn'] = /^https?\:\/\//.test(avatar_cdn) ? avatar_cdn : _avatarSetting['cdn']

        vm.cfg.pageSize = !isNaN(pageSize) ? (pageSize < 1 ? 10 : pageSize) : 10;
        
        if (recordIP) recordIPFn(ip=> defaultComment['ip'] = ip)
        let el = vm.cfg.el || null;
        let _el = $(el);
        el = el instanceof HTMLElement ? el : (_el[_el.length - 1] || null);
        if (el){
            vm.$el = $(el);
            vm.$el.addClass('v').attr('data-class','v') 
            _avatarSetting['hide'] && vm.$el.addClass('hide-avatar');
            vm.cfg.meta = (vm.cfg.guest_info || vm.cfg.meta || defaultMeta).filter(v => defaultMeta.indexOf(v) > -1);
            vm.cfg.requiredFields = vm.cfg.requiredFields.filter(v => defaultMeta.indexOf(v) > -1);
            
            let inputEl = (vm.cfg.meta.length == 0 ? defaultMeta : vm.cfg.meta).map(item => {
                let _t = item == 'mail' ? 'email' : 'text';
                return defaultMeta.indexOf(item) > -1 ? `<input name="${item}" placeholder="${vm.i18n.t(item)}" class="v${item} vinput" type="${_t}">` : ''
            });
            let vwrap = 
                '<div class="vpanel"><div class="vwrap">' +
                    `<p class="cancel-reply text-right" style="display:none;" title="${vm.i18n.t('cancelReply')}">`+
                        `<svg class="vicon cancel-reply-btn" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4220" width="22" height="22"><path d="M796.454 985H227.545c-50.183 0-97.481-19.662-133.183-55.363-35.7-35.701-55.362-83-55.362-133.183V227.545c0-50.183 19.662-97.481 55.363-133.183 35.701-35.7 83-55.362 133.182-55.362h568.909c50.183 0 97.481 19.662 133.183 55.363 35.701 35.702 55.363 83 55.363 133.183v568.909c0 50.183-19.662 97.481-55.363 133.183S846.637 985 796.454 985zM227.545 91C152.254 91 91 152.254 91 227.545v568.909C91 871.746 152.254 933 227.545 933h568.909C871.746 933 933 871.746 933 796.454V227.545C933 152.254 871.746 91 796.454 91H227.545z" p-id="4221"></path><path d="M568.569 512l170.267-170.267c15.556-15.556 15.556-41.012 0-56.569s-41.012-15.556-56.569 0L512 455.431 341.733 285.165c-15.556-15.556-41.012-15.556-56.569 0s-15.556 41.012 0 56.569L455.431 512 285.165 682.267c-15.556 15.556-15.556 41.012 0 56.569 15.556 15.556 41.012 15.556 56.569 0L512 568.569l170.267 170.267c15.556 15.556 41.012 15.556 56.569 0 15.556-15.556 15.556-41.012 0-56.569L568.569 512z" p-id="4222" ></path></svg>`+
                    `</p>`+
                    `<div class="${`vheader item${inputEl.length}`}">${inputEl.join('')}</div>` +
                    '<div class="vedit">'     +
                        `<textarea id="veditor" class="veditor vinput" placeholder="${vm.cfg.placeholder}"></textarea>`     +
                        '<div class="vrow">'         +
                            '<div class="vcol vcol-60 status-bar"></div>'         +
                            '<div class="vcol vcol-40 vctrl text-right">'             +
                                `<span title="${vm.i18n.t('emoji')}"  class="vicon vemoji-btn"><svg  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16172" width="22" height="22" ><path d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512zM512 56.888889a455.111111 455.111111 0 1 0 455.111111 455.111111 455.111111 455.111111 0 0 0-455.111111-455.111111zM312.888889 512A85.333333 85.333333 0 1 1 398.222222 426.666667 85.333333 85.333333 0 0 1 312.888889 512z" p-id="16173"></path><path d="M512 768A142.222222 142.222222 0 0 1 369.777778 625.777778a28.444444 28.444444 0 0 1 56.888889 0 85.333333 85.333333 0 0 0 170.666666 0 28.444444 28.444444 0 0 1 56.888889 0A142.222222 142.222222 0 0 1 512 768z" p-id="16174"></path><path d="M782.222222 391.964444l-113.777778 59.733334a29.013333 29.013333 0 0 1-38.684444-10.808889 28.444444 28.444444 0 0 1 10.24-38.684445l113.777778-56.888888a28.444444 28.444444 0 0 1 38.684444 10.24 28.444444 28.444444 0 0 1-10.24 36.408888z" p-id="16175"></path><path d="M640.568889 451.697778l113.777778 56.888889a27.875556 27.875556 0 0 0 38.684444-10.24 27.875556 27.875556 0 0 0-10.24-38.684445l-113.777778-56.888889a28.444444 28.444444 0 0 0-38.684444 10.808889 28.444444 28.444444 0 0 0 10.24 38.115556z" p-id="16176"></path></svg></span>`+
                                `<span title="${vm.i18n.t('preview')}" class="vicon vpreview-btn"><svg  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17688" width="22" height="22"><path d="M502.390154 935.384615a29.538462 29.538462 0 1 1 0 59.076923H141.430154C79.911385 994.461538 29.538462 946.254769 29.538462 886.153846V137.846154C29.538462 77.745231 79.950769 29.538462 141.390769 29.538462h741.218462c61.44 0 111.852308 48.206769 111.852307 108.307692v300.268308a29.538462 29.538462 0 1 1-59.076923 0V137.846154c0-26.899692-23.355077-49.230769-52.775384-49.230769H141.390769c-29.420308 0-52.775385 22.331077-52.775384 49.230769v748.307692c0 26.899692 23.355077 49.230769 52.775384 49.230769h360.999385z" p-id="17689"></path><path d="M196.923077 216.615385m29.538461 0l374.153847 0q29.538462 0 29.538461 29.538461l0 0q0 29.538462-29.538461 29.538462l-374.153847 0q-29.538462 0-29.538461-29.538462l0 0q0-29.538462 29.538461-29.538461Z" p-id="17690"></path><path d="M649.846154 846.769231a216.615385 216.615385 0 1 0 0-433.230769 216.615385 216.615385 0 0 0 0 433.230769z m0 59.076923a275.692308 275.692308 0 1 1 0-551.384616 275.692308 275.692308 0 0 1 0 551.384616z" p-id="17691"></path><path d="M807.398383 829.479768m20.886847-20.886846l0 0q20.886846-20.886846 41.773692 0l125.321079 125.321079q20.886846 20.886846 0 41.773693l0 0q-20.886846 20.886846-41.773693 0l-125.321078-125.321079q-20.886846-20.886846 0-41.773693Z" p-id="17692"></path></svg></span>`+
                            '</div>'     +
                        '</div>' +
                    '</div>' +
                    '<div class="vrow">'     +
                        '<div class="vcol vcol-30" >'         +
                            '<a alt="Markdown is supported" href="https://guides.github.com/features/mastering-markdown/" class="vicon" target="_blank">'             +
                                '<svg class="markdown" viewBox="0 0 16 16" version="1.1" width="16" height="16" aria-hidden="true"><path fill-rule="evenodd" d="M14.85 3H1.15C.52 3 0 3.52 0 4.15v7.69C0 12.48.52 13 1.15 13h13.69c.64 0 1.15-.52 1.15-1.15v-7.7C16 3.52 15.48 3 14.85 3zM9 11H7V8L5.5 9.92 4 8v3H2V5h2l1.5 2L7 5h2v6zm2.99.5L9.5 8H11V5h2v3h1.5l-2.51 3.5z"></path></svg>'         +
                            '</a>'     +
                        '</div>'     +
                        '<div class="vcol vcol-70 text-right">'         +
                            `<button type="button"  title="Cmd|Ctrl+Enter" class="vsubmit vbtn">${vm.i18n.t('submit')}</button>`     +
                        '</div>' +
                    '</div>' +
                    '<div class="vemojis" style="display:none;"></div>' +
                    '<div class="vinput vpreview" style="display:none;"></div>' +
                '</div></div>'            + 
                `<div class="vcount" style="display:none;"><span class="vnum">0</span> ${vm.i18n.t('comments')}</div>`            + 
                '<div class="vload-top text-center" style="display:none;"><i class="vspinner" style="width:30px;height:30px;"></i></div>' +
                '<div class="vcards"></div>'            + 
                '<div class="vload-bottom text-center" style="display:none;"><i class="vspinner" style="width:30px;height:30px;"></i></div>' +
                '<div class="vempty" style="display:none;"></div>'            + 
                `<div class="vpage txt-center" style="display:none"><button type="button" class="vmore vbtn">${vm.i18n.t('more')}</button></div>`            + 
                `<div class="vpower txt-right">Powered By <a href="https://valine.js.org" target="_blank">Valine</a><br>v${VERSION}</div>`;
            vm.$el.html(vwrap);
            vm.$el.find('.cancel-reply').on('click',e=>{
                vm.reset()
            })
            // Empty Data
            let vempty = vm.$el.find('.vempty');
            vm.$nodata = {
                show(txt) {
                    vempty.html(txt || vm.i18n.t('sofa')).show()
                    return vm;
                },
                hide() {
                    vempty.hide()
                    return vm;
                }
            }
            // loading
            let $LoadBarBottom = vm.$el.find('.vload-bottom'),
                $loadBarTop = vm.$el.find('.vload-top');
            vm.$loading = {
                show(mt) {
                    mt && $loadBarTop.show() || $LoadBarBottom.show()
                    vm.$nodata.hide();
                    return vm;
                },
                hide() {
                    $loadBarTop.hide()
                    $LoadBarBottom.hide()
                    vm.$el.find('.vcard').length === 0 && vm.$nodata.show()
                    return vm;
                }
            };
        }
        lcLoader(vm.cfg,e => {
            console.log(2)
            // get comment count
            let els = $('.valine-comment-count'),
                currIdx = 0;
            (function vccIterator(els){
                let el = els[currIdx++];
                if (el) {
                    let k = $(el).attr('data-xid');
                    !!k && vm.Q(k).count().then(n => {
                        el.innerText = n
                        vccIterator(els)
                    }).catch(ex => {
                        el.innerText = 0
                    })
                }
            })(els)
    
            // Counter
            visitor && CounterFactory.add(AV.Object.extend('Counter'),vm.cfg.path);
            console.log(3)
            // Bind Event
            vm.$el && vm.bind();
        })
    } catch (ex) {
        console.log(ex)
        ErrHandler(vm,ex,'init')
    }
}

// 新建Counter对象
let createCounter = function (Counter, o) {
    let newCounter = new Counter();
    let acl = new AV.ACL();
    acl.setPublicReadAccess(true);
    acl.setPublicWriteAccess(true);
    newCounter.setACL(acl);
    newCounter.set('url', o.url)
    newCounter.set('xid', o.xid)
    newCounter.set('title', o.title)
    newCounter.set('time', 1)
    newCounter.save().then(ret => {
        $(o.el).find('.leancloud-visitors-count').text(1)
    }).catch(ex => {
        console.log(ex)
    });
}
let CounterFactory = {
    add(Counter,currPath) {
        let vm = this
        let lvs = $('.leancloud_visitors,.leancloud-visitors');
        if (lvs.length === 1) {
            let lv = lvs[0];
            let url = decodeURI($(lv).attr('id'));
            let title = $(lv).attr('data-flag-title');
            let xid = encodeURI(url);
            let o = {
                el: lv,
                url: url,
                xid: xid,
                title: title
            }
            // 判断是否需要+1
            if (decodeURI(url) === decodeURI(currPath)) {
                let q = new AV.Query(Counter);
                q.equalTo('url', url);
                q.find().then(ret => {
                    
                    if (ret.length > 0) {
                        let v = ret[0];
                        v.increment("time");
                        v.save().then(rt => {
                            $(lv).find( '.leancloud-visitors-count').text(rt.get('time'))
                        }).catch(ex => {
                            console.log(ex)
                        });
                    } else {
                        createCounter(Counter, o)
                    }
                }).catch(ex => {
                    console.log(ex)
                    if(ex.code == 101) createCounter(Counter, o)
                    else ErrHandler(vm,ex)
                    
                })
            } else CounterFactory.show(Counter, lvs)
        } else CounterFactory.show(Counter, lvs)
    },
    show(Counter, lvs) {
        let COUNT_CONTAINER_REF = '.leancloud-visitors-count',urls = [];
        // 重置所有计数
        lvs.forEach(el=>{
            let cel = $(el).find(COUNT_CONTAINER_REF);
            if (cel) cel.text('0')
            urls.push(/\%/.test($(el).attr('id')) ? decodeURI($(el).attr('id')) : $(el).attr('id'))
        })
        if (urls.length) {
            let query = new AV.Query(Counter);
            query.containedIn('url', urls);
            query.find().then(ret => {
                if (ret.length > 0) {
                // let els = $(`.leancloud_visitors,.leancloud-visitors`);
                lvs.forEach(el=>{
                    ret.forEach(item => {
                        let url = item.get('xid') || encodeURI(item.get('url')),
                            time = item.get('time'),
                            $el = $(el),
                            id = $el.attr('id')
                            if((/\%/.test(id) ? id : encodeURI(id)) == url){
                                let cel = $el.find(COUNT_CONTAINER_REF);
                                if (cel) cel.text(time)
                            }
                    })
                })
                }
            }).catch(ex => {
                console.log(ex)
            })
        }
    }
}

/**
 * LeanCloud SDK Query Util
 * @param {String} url 
 * @param {String} id
 */
ValineFactory.prototype.Q = function (k) {
    let vm = this,
        len = arguments.length,
        className = vm['config']['clazzName'];
    if (len == 1) {
        let notExist = new AV.Query(className);
        notExist.doesNotExist('rid');
        let isEmpty = new AV.Query(className);
        isEmpty.equalTo('rid', '');
        let q = AV.Query.or(notExist, isEmpty);
        if (k === '*') q.exists('url');
        else q.equalTo('url', decodeURI(k));
        q.addDescending('createdAt');
        q.addDescending('insertedAt');
        return q;
    } else {
        let ids = JSON.stringify(arguments[1]).replace(/(\[|\])/g, '');
        let cql = `select * from ${className} where rid in (${ids}) order by -createdAt,-createdAt`;
        return AV.Query.doCloudQuery(cql)
    }
}

/**
 * install Multi language support
 * @param {String} key langName
 * @param {Object} mode langSource
 */
ValineFactory.prototype.installLocale = function (key, mode) {
    let vm = this;
    vm.i18n(key, mode)
    return vm;
}

/**
 * 
 * @param {String} path 
 */
ValineFactory.prototype.setPath = function(v) {
    this.config.path = v
    return this
}

/**
 * Bind Event
 */
ValineFactory.prototype.bind = function () {
    let vm = this;
    // load emojis
    let _vemojis = vm.$el.find('.vemojis'),
        _vpreview = vm.$el.find('.vpreview'),
        _emojiCtrl = vm.$el.find('.vemoji-btn'),
        _vpreviewCtrl = vm.$el.find(`.vpreview-btn`),
        _veditor = vm.$el.find('.veditor'),
        emojiData = Emoji.maps,
        emojiLoaded = false,
        loadEmojiEvt = e => {
            let _is = []
            for (let key in emojiData) {
                if (emojiData.hasOwnProperty(key)) {
                    !!Emoji.build(key) && _is.push(`<i title="${key}" >${Emoji.build(key)}</i>`)
                }
            }
            _vemojis.html(_is.join(''));
            emojiLoaded = true;
            _vemojis.find('i').on('click',function(e){
                e.preventDefault()
                _insertAtCaret(_veditor[0], ` :${$(this).attr('title')}:`)
            })
        };
    vm.$emoji = {
        show() {
            !emojiLoaded && loadEmojiEvt()
            vm.$preview.hide();
            _vemojis.show();
            _emojiCtrl.addClass('actived');
            return vm.$emoji
        },
        hide() {
            _emojiCtrl.removeClass('actived');
            _vemojis.hide();
            return vm.$emoji
        }
    }
    vm.$preview = {
        show() {
            if (TEMP_COMMENT_CTX) {
                vm.$emoji.hide();
                _vpreviewCtrl.addClass('actived');
                _vpreview.html(TEMP_COMMENT_CTX).show()
                _activeOtherFn()
            }else vm.$preview.hide()
            return vm.$preview
        },
        hide() {
            _vpreviewCtrl.removeClass('actived');
            _vpreview.hide().html('')
            return vm.$preview
        }
    }

    /**
     * 评论框内容变化事件
     * @param {HTMLElement} el 
     */
    let syncContentEvt = $el => {
        let TEMP_CTX = md($el.val() || '')
        if(!TEMP_CTX) vm.$preview.hide()
        if(TEMP_COMMENT_CTX == TEMP_CTX) return
        TEMP_COMMENT_CTX = TEMP_CTX
        _vpreviewCtrl.hasClass('actived') > -1 && TEMP_COMMENT_CTX !=_vpreview.html() && (_vpreview.html(TEMP_COMMENT_CTX)) ;
        autosize($el[0])
        _activeOtherFn()
    }
    _emojiCtrl.on('click',e => {
        _emojiCtrl.hasClass('actived') ? vm.$emoji.hide() : vm.$emoji.show()
    })
    _vpreviewCtrl.on('click',e => {
        _vpreviewCtrl.hasClass('actived') ? vm.$preview.hide() : vm.$preview.show()
    })
    let meta = vm.cfg.meta;
    let inputs = {};

    // 同步操作
    let inputMapping = {
        veditor: "comment"
    }
    meta.forEach(item=>{
        inputMapping[`v${item}`] = item;
    })
    for (let i in inputMapping) {
        if (inputMapping.hasOwnProperty(i)) {
            let _v = inputMapping[i];
            let $el = vm.$el.find(`.${i}`);
            inputs[_v] = $el;
            $el.on('input change blur propertychange',e => {
                if(vm.cfg.enableQQ && e.type === 'blur' && _v === 'nick'){
                    if(!isNaN($el.val())) {
                        fetchQQFn($el.val(),ret=>{
                            let name = ret['nick'] || $el.val(),
                                qqMail = ret['qq']+'@qq.com'
                            $('.vnick').val(name)
                            $('.vmail').val(qqMail)
                            defaultComment['nick']= name
                            defaultComment['mail']= qqMail
                            defaultComment['QQAvatar'] = ret['pic']
                        })
                    } else {
                        if($.store.get(QQCacheKey) && $.store.get(QQCacheKey)['nick'] != $el.val()){
                            $.store.remove(QQCacheKey)
                            defaultComment['nick']= $el.val()
                            defaultComment['mail']= ''
                            defaultComment['QQAvatar'] = ''
                        }
                    }
                }
                if (_v === 'comment') syncContentEvt($el)
                else defaultComment[_v] = $.escape($el.val().replace(/(^\s*)|(\s*$)/g, "")).substring(0,40);
            });
        }
    }
    let _insertAtCaret = (field, val) => {
        if (document.selection) {
            //For browsers like Internet Explorer
            field.focus();
            let sel = document.selection.createRange();
            sel.text = val;
            field.focus();
        } else if (field.selectionStart || field.selectionStart == '0') {
            //For browsers like Firefox and Webkit based
            let startPos = field.selectionStart;
            let endPos = field.selectionEnd;
            let scrollTop = field.scrollTop;
            field.value = field.value.substring(0, startPos) + val + field.value.substring(endPos, field.value.length);
            field.focus();
            field.selectionStart = startPos + val.length;
            field.selectionEnd = startPos + val.length;
            field.scrollTop = scrollTop;
        } else {
            field.focus();
            field.value += val;
        }
        setTimeout(x=>{
            syncContentEvt($(field))
        },100)
        // autosize(field)
    }
    let PAGE = {
            no:1,
            size: vm.cfg.pageSize,
            skip: vm.cfg.pageSize,
        },
        $moreBtn = vm.$el.find('.vpage');
    
    $moreBtn.on('click', e => {
        $moreBtn.hide();
        PAGE['no']++
        query();
    })
    let query = () => {
        let size = PAGE['size'],
            no = PAGE['no'],
            count = Number(vm.$el.find('.vnum').text());
        vm.$loading.show();
        let cq = vm.Q(vm.cfg.path);
        cq.limit(size);
        cq.skip((no - 1) * size);
        cq.find().then(rets => {
            PAGE['skip'] = PAGE['size'];
            if(rets && rets.length){
                let rids = []
                rets.forEach(ret=>{
                    rids.push(ret.id)
                    insertDom(ret, vm.$el.find('.vcards'), !0)
                })
                // load children comment
                vm.Q(vm.cfg.path, rids).then(ret => {
                    let kids = ret && ret.results || []
                    kids.forEach(child=>{
                        insertDom(child, $(`.vquote[data-self-id="${child.get('rid')}"]`))
                        // console.log(vm.$el.find(`.vcard[id="${child.id}"]>.vquote:first`))
                    }).catch(ex=>{
                        console.log(ex)
                    })
                })
                size * no < count ? $moreBtn.show() : $moreBtn.hide() ;
                _activeOtherFn()
            }else vm.$nodata.show()
            vm.$loading.hide();
        }).catch(ex => {
            console.log(ex)
            vm.$loading.hide()
            ErrHandler(vm,ex,'query')
        })
    }
    vm.Q(vm.cfg.path).count().then(num => {
        if (num > 0) {
            vm.$el.find('.vcount').show().find('.vnum').text(num);
            query();
        } else {
            vm.$loading.hide();
        }
    }).catch(ex => {
        console.log(4)
        ErrHandler(vm,ex,'count')
        return
    });

    let insertDom = (rt, node, mt) => {
        let $vcard = $(`<div class="vcard" id="${rt.id}"></div>`),
            ua = rt.get('ua'), uaMeta='';
        if (!!ua && !/ja/.test(vm.cfg.lang)) {
            ua = $.detect(ua);
            uaMeta = `<span class="vsys">${ua.browser} ${ua.version}</span> <span class="vsys">${ua.os} ${ua.osVersion}</span>`;
        }
        if(vm.cfg.path === '*') uaMeta = `<a href="${rt.get('url')}" class="vsys">${rt.get('url')}</a>`
        let _t = rt.get('link')?(/^https?\:\/\//.test(rt.get('link')) ? rt.get('link') : 'http://'+rt.get('link')) : '',
            _nick = _t ? `<a class="vnick" rel="nofollow" href="${_t}" target="_blank" >${rt.get("nick")}</a>` : `<span class="vnick">${rt.get('nick')}</span>`,
            _img = _avatarSetting['hide'] 
                ? '' 
                : ((vm.cfg.enableQQ && rt.get('QQAvatar')) 
                ? `<img class="vimg" src="${rt.get('QQAvatar')}" referrerPolicy="no-referrer"/>` 
                : `<img class="vimg" src="${_avatarSetting['cdn']+md5(rt.get('mail'))+_avatarSetting['params']}">`);
            
        let html = 
            `${_img}`+
            `<div class="vh">`+
                `<div class="vhead">${_nick} ${uaMeta}</div>`+
                '<div class="vmeta">'+
                    `<span class="vtime" >${timeAgo(rt.get('insertedAt'),vm.i18n)}</span>`+
                    `<span class="vat" data-vm-id="${rt.get('rid')||rt.id}" data-self-id="${rt.id}">${vm.i18n.t('reply')}</span>`+
                '</div>'+
                `<div class="vcontent" data-expand="${vm.i18n.t('expand')}">${xss(rt.get("comment"))}</div>`+
                `<div class="vreply-wrapper" data-self-id="${rt.id}"></div>`+
                `<div class="vquote" data-self-id="${rt.id}"></div>`+
            `</div>`;
        $vcard.html(html)
        let _vat = $vcard.find('.vat');
        $vcard.find('a').forEach(a=>{
            if(a && !$(a).hasClass('at')){
                $(a).attr({
                    'target': '_blank',
                    'rel': 'noopener'
                })
            }
        })
        if (mt) node.append($vcard);
        else node.prepend($vcard) //node[0].insertBefore($vcard[0], _vlis[0]);
        let _vcontent = $vcard.find('.vcontent');
        if (_vcontent) expandEvt(_vcontent);
        if (_vat) bindAtEvt(_vat, rt);
    }

    let atData = {}
    // at event
    let bindAtEvt = ($el, rt) => {
        $el.on('click',e=>{
            let vmId =$el.attr('data-vm-id'),
                selfId =$el.attr('data-self-id'),
                editor = vm.$el.find('.vwrap'),
                at = `@${$.escape(rt.get('nick'))}`;
            $(`.vreply-wrapper[data-self-id="${selfId}"]`).append(editor).find('.cancel-reply').show();
            atData = {
                'at': $.escape(at) + ' ',
                'rid': vmId,
                'pid': selfId,
                'rmail': rt.get('mail'),
            }
            inputs['comment'].attr({'placeholder':at})[0].focus();
        })
    }


    let _activeOtherFn = () => {
        setTimeout(function () {
            try {
                if (vm.cfg.mathjax && ('MathJax' in window) && ('version' in window['MathJax'])) /^3.*/.test(window['MathJax']['version']) &&  MathJax.typeset() || MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.querySelector(".v")])
                if('renderMathInElement' in window) renderMathInElement($('.v')[0],{
                    delimiters:[
                        {left: '$$', right: '$$', display: true},
                        {left: '$', right: '$', display: false}
                    ]
                })
            } catch (ex) {}
        }, 100)
    }

    // expand event
    let expandEvt = $el => {
        setTimeout(function () {
            if ($el[0].offsetHeight > 200) {
                $el.addClass('expand');
                $el.on('click',e => {
                    $el.removeClass('expand');
                })
            }
        })
    }

    // cache
    let getCache = s => {
        s = $.store.get(MetaCacheKey) || s;
        if (s) {
            for (let i in meta) {
                let k = meta[i];
                vm.$el.find(`.v${k}`).val($.unescape(s[k]));
                defaultComment[k] = s[k];
            }
        }
        let x = $.store.get(QQCacheKey)
        defaultComment['QQAvatar'] = vm.cfg.enableQQ && !!x && x['pic'] || ''
    }
    getCache();
    // reset form
    vm.reset = () => {
        defaultComment['comment'] = "";
        inputs['comment'].val("");
        syncContentEvt(inputs['comment'])
        inputs['comment'].attr('placeholder', vm.cfg.placeholder);
        atData = {};
        vm.$preview.hide();
        vm.$el.find('.vpanel').append(vm.$el.find('.vwrap'))
        vm.$el.find('.cancel-reply').hide()
        TEMP_COMMENT_CTX = ''
    }

    // submitsubmit
    let $submitBtn = vm.$el.find('.vsubmit');
    let submitEvt = e => {
        if(vm.cfg.requiredFields.indexOf('nick') > -1 && defaultComment['nick'].length < 3){
            inputs['nick'][0].focus();
            vm.$el.find('.status-bar').text(`${vm.i18n.t('nickFail')}`).empty(3000)
            return
        }
        if(vm.cfg.requiredFields.indexOf('mail') > -1 && !/[\w-\.]+@([\w-]+\.)+[a-z]{2,3}/.test(defaultComment['mail'])){
            inputs['mail'][0].focus();
            vm.$el.find('.status-bar').text(`${vm.i18n.t('mailFail')}`).empty(3000)
            return
        }
        if (TEMP_COMMENT_CTX == '') {
            inputs['comment'][0].focus();
            return;
        }
        defaultComment['comment'] = TEMP_COMMENT_CTX
        defaultComment['nick'] = defaultComment['nick'] || 'Anonymous';
        let lastUpdated = $.store.get('vlx');
        if(lastUpdated){
            let now = Date.now() / 1000
            if(now - lastUpdated / 1000 < 20){
                vm.$el.find('.status-bar').text(vm.i18n.t('busy')).empty(3000)
                return 
            }
        }
        commitEvt();
        
    }

    // setting access
    let getAcl = () => {
        let acl = new AV.ACL();
        acl.setPublicReadAccess(!0);
        acl.setPublicWriteAccess(!1);
        return acl;
    }

    let commitEvt = () => {
        $.store.set('vlx',Date.now());
        $submitBtn.attr({'disabled':!0})
        vm.$loading.show(!0);
        // 声明类型
        let Ct = AV.Object.extend(vm.cfg.clazzName || 'Comment');
        // 新建对象
        let comment = new Ct();
        defaultComment['url'] = decodeURI(vm.cfg.path);
        defaultComment['insertedAt'] = new Date();
        if (atData['rid']) {
            let pid = atData['pid'] || atData['rid'];
            comment.set('rid', atData['rid']);
            comment.set('pid', pid);
            defaultComment['comment'] = TEMP_COMMENT_CTX.replace('<p>', `<p><a class="at" href="#${pid}">${atData['at']}</a> , `);
        }
        for (let i in defaultComment) {
            if (defaultComment.hasOwnProperty(i)) {
                let _v = defaultComment[i];
                comment.set(i, _v);
            }
        }
        comment.setACL(getAcl());
        comment.save().then(ret => {
            defaultComment['nick'] != 'Anonymous' && $.store.set(MetaCacheKey,{
                nick: defaultComment['nick'],
                link: defaultComment['link'],
                mail: defaultComment['mail']
            });
            let $count = vm.$el.find('.vnum');
            try {
                if (atData['rid']) insertDom(ret, $(`.vquote[data-self-id="${atData['rid']}"]`),!0)
                else {
                    if (Number($count.text())) {
                        $count.text(Number($count.text()) + 1);
                    } else vm.$el.find('.vcount').show().find('.vnum').text(Number($count.text()) + 1)
                    insertDom(ret, vm.$el.find('.vcards'));
                    PAGE['skip']++
                }
                $submitBtn.removeAttr('disabled')
                vm.$loading.hide();
                vm.reset();
            } catch (ex) {
                ErrHandler(vm,ex,'save');
            }
        }).catch(ex => {
            ErrHandler(vm,ex,'commitEvt');
        })
    }


    $submitBtn.on('click', submitEvt);
    $(document).on('keydown', e => {
        e = event || e;
        let keyCode = e.keyCode || e.which || e.charCode;
        let ctrlKey = e.ctrlKey || e.metaKey;
        // Shortcut key
        ctrlKey && keyCode === 13 && submitEvt()
        // tab key
        if (keyCode === 9) {
            let focus = document.activeElement.id || ''
            if (focus == 'veditor') {
                e.preventDefault();
                _insertAtCaret(_veditor[0], '    ');
            }
        }
    }).on('paste', e => {
        let clipboardData = "clipboardData" in e ? e.clipboardData : (e.originalEvent && e.originalEvent.clipboardData || window.clipboardData)
        clipboardData && fileHandle(clipboardData.items,true)
    })

    _veditor.on('dragenter dragleave dragover drop',e => {
        e.stopPropagation();  
        e.preventDefault();  
        if(e.type === 'drop') fileHandle(e.dataTransfer.items)
    })

    let fileHandle = (items,isPaste) => {
        let images = []
        for (let i = 0,len = items.length; i <len; i++) {
            let item = items[i]
            if(item.kind === 'string' && item.type.match('^text/html')){
                !isPaste && item.getAsString(str=>{
                    // 处理文字
                    str && _insertAtCaret(_veditor[0], str.replace(/<[^>]+>/g, ""));
                })
            } else if (item.type.indexOf('image') !== -1) {
                images.push(item.getAsFile());
                continue;
            }
        }
        iterator(images)
    }

    let iterator = (images,idx) =>{
        idx = idx || 0;
        let len = images.length;
        if(len > 0){
            let image = images[idx];
            $submitBtn.attr({'disabled':!0})
            let uploadText = `![Uploading ${image['name']}...]()`;
            _insertAtCaret(_veditor[0], uploadText);
            uploadImage(image,function(ret){
                if(ret['code'] != 500) {
                    _veditor.val(_veditor.val().replace(uploadText,`![${image['name']}](${ret['data']['url']})\r\n`))
                    autosize(_veditor[0])
                    if(++idx<len) iterator(images,idx)
                    else $submitBtn.removeAttr('disabled')
                }else {
                    _veditor.val(_veditor.val().replace(uploadText,''))
                    autosize(_veditor[0])
                    vm.$el.find('.status-bar').text(ret.msg).empty(3000)
                    $submitBtn.removeAttr('disabled')
                }
            })
        }
    }


    let uploadImage = (file,callback)=>{
        let formData = new FormData();
        formData.append('image', file);
        $.ajax({
            type:'post',
            url:'https://pic.alexhchu.com/api/upload',
            data:formData,
            success(ret){
                callback && callback(ret)
            }
        })
        // let formData = new FormData();
        // formData.append('image', file);
        // let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
        // xhr.onreadystatechange = function () {
        //     if (xhr.readyState == 4) {
        //         if(xhr.status === 200){
        //             try {
        //                 let json = JSON.parse(xhr.responseText);
        //                 callback && callback(null,json)
        //             } catch (err) {
        //                 callback && callback(err)
        //             }
        //         }else {
        //             callback && callback(xhr.status)
        //         }
        //     } 
        // }
        // xhr.onerror = callback;
        // xhr.open('POST', 'https://pic.alexhchu.com/api/upload',true);
        // // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        // // xhr.open('POST','https://imgkr.com/api/files/upload',true);
        // xhr.send(formData);
    }

}

function Valine(options) {
    return new ValineFactory(options)
}

module.exports = Valine;
module.exports.default = Valine;